import React from 'react';
import PropTypes from 'prop-types';

import ReactTooltip from 'react-tooltip';

import './CommonTooltip.css';


const CommonTooltip = props => {
  const {
    children,
    id,
    onClose,
    className,
    event,
    globalEventOff,
    clickable,
    place,
    type,
    effect,
    delayHide,
    headerText,
  } = props;

  const calculateClassName = () => {
    let value = 'common-tooltip__component';
    if (className) { value += ` ${className}`; }
    return value;
  };

  return (
    <ReactTooltip
      className={calculateClassName()}
      id={id}
      event={event || 'click'}
      globalEventOff={globalEventOff || 'click'}
      clickable={clickable || true}
      place={place || 'bottom'}
      type={type || 'light'}
      effect={effect || 'float'}
      delayHide={delayHide || 0}
    >
      <div className="tooltip-wrapper">
        <div className="header-wrapper">
          <div className="header-text">
            {headerText}
          </div>
          {onClose &&
            <div
              className="close-icon"
              onClick={onClose}
              role="button"
              tabIndex={-1}
            />
          }
        </div>
        {children}
      </div>
    </ReactTooltip>
  );
};

CommonTooltip.propTypes = {
  onClose: PropTypes.func,
  className: PropTypes.string,
  id: PropTypes.string.isRequired,
  event: PropTypes.string,
  globalEventOff: PropTypes.string,
  clickable: PropTypes.bool,
  place: PropTypes.string,
  type: PropTypes.string,
  effect: PropTypes.string,
  delayHide: PropTypes.number,
  headerText: PropTypes.string,
};

CommonTooltip.defaultProps = {
  onClose: null,
  className: null,
  event: null,
  globalEventOff: null,
  clickable: null,
  place: null,
  type: null,
  effect: null,
  delayHide: null,
  headerText: null,
};

export default CommonTooltip;
